// import logger from 'redux-logger';
import {createStore, applyMiddleware} from 'redux';
import {persistStore} from 'redux-persist';
import thunk from 'redux-thunk';

import rootReducer from '../reducers';
import {getApp} from '../actions/app';

const middlewares = [thunk];

// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger);
// }
export const store = createStore(rootReducer, applyMiddleware(...middlewares));
export const persistor = persistStore(store, {}, () => {
  store.dispatch(getApp({isRehydrationComplete: true}));
});
export default {store, persistor};
